import React, { useState, useEffect, useCallback } from 'react';

const CountdownTimer = ({ endTime, onExpire, className = '', compact = false }) => {
  const calculateTimeLeft = useCallback(() => {
    const diff = new Date(endTime) - new Date();
    if (diff <= 0) return null;

    return {
      hours: Math.floor(diff / (1000 * 60 * 60)),
      minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((diff % (1000 * 60)) / 1000),
    };
  }, [endTime]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      const tl = calculateTimeLeft();
      setTimeLeft(tl);
      if (!tl) {
        clearInterval(timer);
        if (onExpire) onExpire();
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [calculateTimeLeft, onExpire]);

  if (!timeLeft) return null;

  const pad = (n) => String(n).padStart(2, '0');

  if (compact) {
    return (
      <span className={`inline-flex items-center gap-0.5 text-[10px] font-mono font-bold ${className}`}>
        ⏰ {pad(timeLeft.hours)}:{pad(timeLeft.minutes)}:{pad(timeLeft.seconds)}
      </span>
    );
  }

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <span className="text-xs font-medium text-red-600">⚡ Flash Sale ends in</span>
      <div className="flex gap-1">
        {[
          { val: timeLeft.hours, label: 'H' },
          { val: timeLeft.minutes, label: 'M' },
          { val: timeLeft.seconds, label: 'S' },
        ].map(({ val, label }) => (
          <div key={label} className="bg-red-600 text-white text-xs font-mono font-bold
                      px-1.5 py-0.5 rounded min-w-[28px] text-center">
            {pad(val)}<span className="text-red-200 text-[8px] ml-0.5">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CountdownTimer;
